import React from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom';

// Components //
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Gifs from './components/GifContent';

const App = () => {
	return (
		<BrowserRouter>
			<div className="main-container">
				<Header />

				<Switch>
					<Route exact path="/" component={Home} />
					<Route path="/about" component={About} />
					<Route path="/projects" component={Projects} />
					<Route path="/gifs" component={Gifs} />
				</Switch>
			</div>
		</BrowserRouter>
	);
}

export default App;